import { Localization } from '../../localization/localization';
import { getStyledFont2BlueLink } from '../../layout/styledLinks';

export class WebglNotSupportedPopup {
    public static getTroubleshootingLink() {
        const availableTroubleshootingLangs = ['en', 'fr', 'de', 'it', 'pl', 'ko', 'ru', 'tr', 'pt', 'es', 'ar'];
        const defaultLanguage = 'ru';
        let lang = defaultLanguage;

        if (availableTroubleshootingLangs.includes(window.app.config.language)) {
            lang = window.app.config.language;
        }

        return `https://scorewarrior.helpshift.com/a/total-battle/?l=${lang}&s=technical-issues&f=issues-with-webgl`;
    }

    public static getNotSupportedMessage() {
        let message = Localization._n('no_browser_webgl_support');
        const faqLink = getStyledFont2BlueLink('FAQ', WebglNotSupportedPopup.getTroubleshootingLink());
        message += `<br>${Localization._n('check_faq_for_webgl_issues', {link: faqLink})}`;
        return message;
    }
}
